<div class="forms-wrapper">
  <!-- Calendrier -->
  <p-card styleClass="mb-2" class="card-custom calendar-card">
    <ng-template pTemplate="header">
      <div class="p-1 bg-neutral-900 flex items-center">
        <i class="pi pi-calendar mr-2"></i>
        <h3 class="text-base m-0">Période</h3>
      </div>
    </ng-template>
    <div
      class="p-1 week-clickable-calendar"
      (click)="onCalendarClick($any($event))"
    >
      <p-datepicker
        #weekPickerCalendar
        [inline]="true"
        [formControl]="rangeDates"
        selectionMode="range"
        [readonlyInput]="true"
        styleClass="w-full compact-calendar"
        dateFormat="dd/mm/yy"
        [firstDayOfWeek]="1"
        [showWeek]="true"
      ></p-datepicker>
    </div>
  </p-card>

  <!-- Techniciens -->
  <p-card styleClass="mb-2" class="card-custom">
    <ng-template pTemplate="header">
      <div class="p-1 bg-neutral-900 flex items-center">
        <i class="pi pi-users mr-2"></i>
        <h3 class="text-base m-0">Technicien</h3>
      </div>
    </ng-template>

    <div class="p-1">
      <p-select
        [options]="users"
        [formControl]="selectedTechnicianControl"
        optionLabel="fullName"
        dataKey="id"
        [filter]="true"
        [loading]="loadingUsers"
        filterBy="firstname,lastname"
        placeholder="Sélectionner un technicien"
        [style]="{ width: '100%' }"
        styleClass="compact-select"
        [showClear]="true"
        [appendTo]="'body'"
        (onChange)="onTechnicianSelected($event.value)"
      >
        <ng-template let-technician pTemplate="item">
          <div class="flex items-center p-1">
            <div
              class="w-5 h-5 rounded-full flex items-center justify-center mr-1"
              [style.background-color]="technician.color || '#666'"
            >
              <span class="text-white text-xs">
                {{ getTechnicianInitials(technician) }}
              </span>
            </div>
            <span class="text-sm">{{ technician.fullName }}</span>
          </div>
        </ng-template>
        <ng-template let-technician pTemplate="selectedItem">
          <div class="flex items-center" *ngIf="technician">
            <div
              class="w-5 h-5 rounded-full flex items-center justify-center mr-1"
              [style.background-color]="technician.color || '#666'"
            >
              <span class="text-white text-xs">
                {{ getTechnicianInitials(technician) }}
              </span>
            </div>
            <span class="text-sm">{{ technician.fullName }}</span>
          </div>
        </ng-template>
      </p-select>
    </div>
  </p-card>

  <!-- Techniciens proches par distance routière -->
  <p-card styleClass="mb-2" class="card-custom">
    <ng-template pTemplate="header">
      <div class="p-1 bg-neutral-900 flex items-center">
        <i class="pi pi-home mr-2"></i>
        <h3 class="text-base m-0">Domiciles proches</h3>
      </div>
    </ng-template>

    <div class="p-1">
      @if (loadingTechniciansByRoute) {
        <div class="flex justify-center p-2">
          <p-progressSpinner [style]="{ width: '24px', height: '24px' }" />
        </div>
      } @else if (closestTechniciansByRoute.length) {
        <p-scrollPanel styleClass="nearby-technicians-scroll">
          <div class="flex flex-col gap-1 p-1">
            @for (
              item of closestTechniciansByRoute;
              track item.technician.id || $index
            ) {
              <div
                class="tech-card p-1 rounded-md border border-neutral-700 flex items-center cursor-pointer hover:bg-neutral-800"
                (click)="onHomeTechnicianClick(item.technician)"
              >
                <div
                  class="w-6 h-6 rounded-lg flex items-center justify-center mr-2 relative"
                  [style.background-color]="item.technician.color || '#666'"
                >
                  <span class="text-white text-xs">{{
                    getTechnicianInitials(item.technician)
                  }}</span>
                  <span class="absolute -bottom-1 -right-1 text-xs">🏠</span>
                </div>
                <div class="flex-1 min-w-0">
                  <div class="text-xs truncate">
                    {{ item.technician.firstname }}
                    {{ item.technician.lastname }}
                  </div>
                  <div class="text-xs text-neutral-400 flex items-center gap-1">
                    <fa-icon [icon]="faRoute" class="text-xs"></fa-icon>
                    <span
                      ><b>{{ item.distance_km }}</b> km</span
                    >
                    @if (item.duration_min) {
                      <span
                        >• <b>{{ item.duration_min }}</b> min</span
                      >
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </p-scrollPanel>
      } @else {
        <p class="text-xs p-2 text-center text-neutral-400">
          Aucun technicien à proximité
        </p>
      }
    </div>
  </p-card>
</div>
